import React from 'react';
import { connect } from 'react-redux';
import { FttbBlocks } from "../../blocks/constants";
import { getBlocksAliasList } from "../../store/blocks/selectors";
import { getFilteredBlocks } from "./helpers";
export var _SortController = function _SortController(_ref) {
  var children = _ref.children,
    className = _ref.className,
    containerRef = _ref.containerRef;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: containerRef,
    "data-t-id": "components-SortController"
  }, children);
};
var mapStateToProps = function mapStateToProps(state, _ref2) {
  var children = _ref2.children;
  return {
    children: getFilteredBlocks(getBlocksAliasList(state), children, FttbBlocks.HEADING)
  };
};
export var SortController = connect(mapStateToProps)(_SortController);